import React from 'react';
import classNames from 'classnames';

interface PortfolioItemProps {
  title: string;
  description: string;
  image: string;
  tags: string[];
  rating: number;
  index: number;
  className?: string;
  onImageLoad?: (src: string) => void;
}

export function PortfolioItem({
  title,
  description,
  image,
  tags,
  rating,
  index,
  className = '',
  onImageLoad,
}: PortfolioItemProps) {
  return (
    <div className={classNames({'pt-4': index > 1}, className)}>
      <div className="border border-gray-200 rounded-lg overflow-hidden relative break-inside-avoid">
        <div className="aspect-[5/2] w-full relative overflow-hidden">
          <img
            src={image}
            alt={title}
            className="w-full h-full object-cover"
            onLoad={() => {
              onImageLoad?.(image);
            }}
            onError={() => {
              onImageLoad?.(image); // Count as loaded even if it fails
            }}
          />
        </div>
        <div className="p-3 flex flex-col gap-2">
          <div className="flex flex-col gap-1">
            <h3 className="text-md font-bold leading-tight text-gray-800">
              {title}
            </h3>
            <p className="text-md font-normal leading-tight text-gray-500">
              {description}
            </p>
          </div>
          <div className="flex gap-1">
            {tags.map((tag, tagIndex) => (
              <div
                key={tagIndex}
                className="bg-orange-100 rounded-full px-2 py-1 flex items-center justify-center">
                <span className="text-xs font-normal leading-tight text-orange-800">
                  {tag}
                </span>
              </div>
            ))}
          </div>
        </div>
        <div className="absolute top-2 right-2 bg-primary rounded-full px-2 py-1 flex items-center justify-center">
          <span className="text-xs font-extrabold leading-tight text-white">
            {rating}/10
          </span>
        </div>
      </div>
    </div>
  );
}
